<div *ngIf="showTrigger && image as item" class="image-lightbox-thumbnail" [style.width]="thumbnail.width || '100%'"
     [class.image-lightbox-thumbnail--framed]="!!thumbnail.aspectRatio"
     [style.aspect-ratio]="thumbnail.aspectRatio || null"
     [style.max-height]="thumbnail.aspectRatio ? (thumbnail.maxHeight || '480px') : null"
     [style.height]="thumbnail.height || null" [style.border-radius]="thumbnail.borderRadius || '10px'">
  <p-skeleton *ngIf="item.state === 'waiting' || item.state === 'loading'" width="100%"
              [height]="thumbnail.aspectRatio ? '100%' : (thumbnail.height || thumbnail.skeletonHeight || '12rem')"
              [attr.aria-label]="'shared.image_lightbox.loading' | translate"></p-skeleton>
  <button *ngIf="item.thumbnailUrl && item.state !== 'error'" pButton type="button"
          [attr.data-lightbox-image]="item.id"
          class="p-button-text p-0 image-lightbox-trigger" [hidden]="item.state !== 'ready'"
          [style.height]="thumbnail.aspectRatio ? '100%' : (thumbnail.height || null)"
          [attr.aria-label]="'shared.image_lightbox.open' | translate" (click)="open($event)">
    <img [src]="item.thumbnailUrl" [alt]="item.alt" decoding="async"
         [style.height]="thumbnail.aspectRatio ? '100%' : (thumbnail.height || null)" [style.max-height]="thumbnail.maxHeight || '480px'"
         [style.object-fit]="thumbnail.fit || 'contain'"
         (load)="loaded.emit(item.id)" (error)="loadFailed.emit(item.id)">
    <span class="image-lightbox-thumbnail-mask flex align-items-center justify-content-center" aria-hidden="true">
      <i class="pi pi-eye"></i>
    </span>
  </button>
  <div *ngIf="item.state === 'error'" class="image-lightbox-thumbnail-error flex flex-column align-items-center justify-content-center gap-1 p-1"
       [style.height]="thumbnail.aspectRatio ? '100%' : (thumbnail.height || null)" role="alert">
    <span class="text-xs">{{ 'shared.image_lightbox.load_failed' | translate }}</span>
    <button pButton type="button" class="p-button-text" [label]="'common.retry' | translate" (click)="retryImage(item)"></button>
  </div>
</div>

<p-dialog *ngIf="browser && mounted" #lightboxDialog [visible]="visible" (visibleChange)="close()"
          [modal]="true" appendTo="body" [closable]="false" [closeOnEscape]="false"
          [draggable]="false" [resizable]="false" [dismissableMask]="false" [baseZIndex]="6002"
          [transitionOptions]="usesGestures ? '0ms' : '150ms cubic-bezier(0, 0, 0.2, 1)'"
          [styleClass]="hasThumbnails ? 'app-image-lightbox app-image-lightbox--thumbnails' : 'app-image-lightbox'" maskStyleClass="app-image-lightbox-mask"
          (onShow)="onShow()" (onHide)="onHide()">
  <ng-template pTemplate="header">
    <div class="image-lightbox-toolbar flex align-items-center justify-content-end gap-1 w-full"
         (click)="$event.stopPropagation()">
      <span class="p-sr-only" [id]="lightboxDialog.ariaLabelledBy">{{ 'shared.image_lightbox.title' | translate }}</span>
      <button pButton type="button" icon="pi pi-refresh" class="p-button-rounded p-button-text"
              [attr.aria-label]="'shared.image_lightbox.rotate_right' | translate" (click)="rotate(90)"></button>
      <button pButton type="button" icon="pi pi-undo" class="p-button-rounded p-button-text"
              [attr.aria-label]="'shared.image_lightbox.rotate_left' | translate" (click)="rotate(-90)"></button>
      <button pButton type="button" icon="pi pi-search-minus" class="p-button-rounded p-button-text"
              [disabled]="scale <= (usesGestures ? 1 : 0.5)" [attr.aria-label]="'shared.image_lightbox.zoom_out' | translate" (click)="zoom(-0.1)"></button>
      <button pButton type="button" icon="pi pi-search-plus" class="p-button-rounded p-button-text"
              [disabled]="scale >= (usesGestures ? 3 : 1.5)" [attr.aria-label]="'shared.image_lightbox.zoom_in' | translate" (click)="zoom(0.1)"></button>
      <button pButton type="button" icon="pi pi-times" class="p-button-rounded p-button-text image-lightbox-close"
              [attr.aria-label]="'common.close' | translate" (click)="close()"></button>
    </div>
  </ng-template>
  <div class="image-lightbox-stage" #previewStage [class.image-lightbox-stage--chat]="usesGestures" data-gallery="images" (click)="$event.stopPropagation()">
    <swiper [config]="config" [initialSlide]="activeIndex" [allowTouchMove]="scale <= 1"
            (swiper)="onSwiper($event)" (slideChange)="onSlideChange($event)"
            (zoomChange)="onZoomChange($event)" (doubleTap)="onDoubleTap($event)">
      <ng-template swiperSlide *ngFor="let item of images; let i = index; trackBy: trackImage">
        <div class="image-lightbox-slide">
          <ng-container *ngIf="usesGestures; else standardImage">
            <img *ngIf="isPreviewReady(item)" class="image-lightbox-backdrop" [src]="item.previewUrl" alt="" aria-hidden="true" draggable="false">
            <p-skeleton *ngIf="!isPreviewReady(item) && !isPreviewError(item)" width="min(70vw, 40rem)" height="60vh"></p-skeleton>
            <div class="swiper-zoom-container">
              <div *ngIf="item.previewUrl && !isPreviewReloading(item)" class="image-lightbox-zoom-target swiper-zoom-target"
                   [style.width.px]="chatImageBox(item, i)?.width" [style.height.px]="chatImageBox(item, i)?.height">
                <img class="image-lightbox-picture" [src]="item.previewUrl" [alt]="item.alt" draggable="false"
                     [style.width.px]="chatImageBox(item, i)?.imageWidth" [style.height.px]="chatImageBox(item, i)?.imageHeight"
                     [style.transform]="'translate(-50%, -50%) rotate(' + (i === activeIndex ? rotation : 0) + 'deg)'"
                     (load)="onPreviewLoaded(item, $event)" (error)="onPreviewError(item)">
              </div>
            </div>
            <div *ngIf="isPreviewError(item)" class="image-lightbox-chat-error flex align-items-center gap-2 p-3" role="alert">
              <span>{{ 'shared.image_lightbox.load_failed' | translate }}</span>
              <button pButton type="button" [label]="'common.retry' | translate" (click)="retryImage(item)"></button>
            </div>
          </ng-container>
          <ng-template #standardImage>
          <img *ngIf="isPreviewReady(item)" class="image-lightbox-backdrop"
               [src]="item.previewUrl" alt="" aria-hidden="true" draggable="false">
          <p-skeleton *ngIf="!isPreviewReady(item) && !isPreviewError(item)" width="min(70vw, 40rem)" height="60vh"></p-skeleton>
          <img *ngIf="item.previewUrl && !isPreviewError(item) && !isPreviewReloading(item)" class="image-lightbox-picture"
               [src]="item.previewUrl" [alt]="item.alt" draggable="false"
               [style.visibility]="isPreviewReady(item) ? 'visible' : 'hidden'"
               [style.transform]="'rotate(' + (i === activeIndex ? rotation : 0) + 'deg) scale(' + (i === activeIndex ? scale : 1) + ')'"
               (load)="onPreviewLoaded(item)" (error)="onPreviewError(item)">
          <div *ngIf="isPreviewError(item)" class="flex flex-column align-items-center gap-2 p-3" role="alert">
            <span>{{ 'shared.image_lightbox.load_failed' | translate }}</span>
            <button pButton type="button" [label]="'common.retry' | translate" (click)="retryImage(item)"></button>
          </div>
          </ng-template>
        </div>
      </ng-template>
    </swiper>
    <button *ngIf="images.length > 1" pButton type="button" icon="pi pi-chevron-left"
            class="p-button-rounded p-button-text image-lightbox-previous" [disabled]="activeIndex === 0"
            [attr.aria-label]="'shared.image_lightbox.previous' | translate" (click)="navigate(-1)"></button>
    <button *ngIf="images.length > 1" pButton type="button" icon="pi pi-chevron-right"
            class="p-button-rounded p-button-text image-lightbox-next" [disabled]="activeIndex === images.length - 1"
            [attr.aria-label]="'shared.image_lightbox.next' | translate" (click)="navigate(1)"></button>
  </div>
  <ng-template pTemplate="footer">
    <nav *ngIf="hasThumbnails" #thumbnailRail class="image-lightbox-thumbnails"
         [attr.aria-label]="'shared.image_lightbox.thumbnails' | translate" (click)="$event.stopPropagation()" (wheel)="onThumbnailWheel($event)">
      <button *ngFor="let item of images; let i = index; trackBy: trackImage" pButton type="button"
              class="p-button-text p-0 image-lightbox-thumbnail-button"
              [attr.aria-current]="i === activeIndex ? 'true' : null"
              [attr.aria-label]="'shared.image_lightbox.go_to_image' | translate:{current: i + 1, total: images.length}"
              (click)="selectImage(i)">
        <img *ngIf="item.thumbnailUrl && !isThumbnailError(item); else thumbnailFallback"
             [src]="item.thumbnailUrl" alt="" loading="lazy" decoding="async" draggable="false"
             (error)="onThumbnailError(item)">
        <ng-template #thumbnailFallback><i class="pi pi-image" aria-hidden="true"></i></ng-template>
      </button>
    </nav>
    <div class="text-center" aria-live="polite">
      {{ 'shared.image_lightbox.position' | translate:{current: activeIndex + 1, total: images.length} }}
    </div>
  </ng-template>
</p-dialog>
